import React, { useState } from 'react'
import PasswordValidation from './PasswordValidation/PasswordValidation';
import './PasswordValidation/index.css'

const InputPassword = ({title, position = 'top', t, passwordValidation, value, handleChangeValue, error}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  return (
    <PasswordValidation position={position} error={error} value={value} validationResult={passwordValidation?.validationResult} t={t}>
      {
        ({showDialog, closeDialog}) => (
          <div style={{ marginBottom: '17px'}}>
            <div className="field-wrapper input required premium-input" style={{ marginBottom: 0}}>
              <input
                onBlur={closeDialog}
                onFocus={showDialog}
                id="register-password"
                type={passwordVisible ? 'text' : 'password'} 
                value={value} 
                onChange={ev => { 
                  handleChangeValue(ev)
                  passwordValidation?.setPassword(ev.target.value)
                }} 
                name="password" 
                className="form-control premium-input" 
                placeholder=" " 
              />
              <span className="placeholder">{title}</span>
              <span toggle="#password" className={!passwordVisible ? "toggle-password" : "toggle-password-closed"} title="ver contraseña" onClick={() => setPasswordVisible(!passwordVisible)}></span>
            </div>
            {value && !passwordValidation.isValid && <b className="error-msg">{t(
              'password does not meet the requirements'
            )}</b>}
          </div>
        )
      }
  </PasswordValidation>
  )
}

export default InputPassword